import httpClient from "../httpClient"

import { formatData } from "../request"
import { encodeRequestParameters } from "../request"

import { apartmentFormat, apartmentSummaryById } from "../formats"

/**
 * Returns a specific apartment and its global related informations
 */
export function getApartmentSummaryById(apartmentId, data) {
    const formatedData = formatData(apartmentSummaryById, data)
    const params = encodeRequestParameters(formatedData)
    return httpClient
        .get("/appart/" + apartmentId + "/summary", { params })
        .then((response) => {
            return response
        })
        .catch((error) => {
            throw error
        })
}

/**
 * Returns a list of apartment
 *
 */
export function getApartmentList(listParam) {
    // const data = formatData(apartmentSummaryById)
    const params = encodeRequestParameters(listParam)
    return httpClient
        .get("/appart", { params })
        .then((response) => {
            return response
        })
        .catch((error) => {
            throw error
        })
}

export function createApartment(data) {
    data = formatData(apartmentFormat, data)
    const params = encodeRequestParameters(data)
    return httpClient
        .post("/appart", params)
        .then((response) => {
            return response
        })
        .catch((error) => {
            throw error
        })
}

export function getApartment(data) {
    data = formatData(apartmentFormat, data)
    return httpClient
        .get("/appart/" + data.id)
        .then((response) => {
            return response
        })
        .catch((error) => {
            throw error
        })
}

export function updateApartment(data) {
    data = formatData(apartmentFormat, data)

    if (data === false) {
        throw "500"
    }

    const params = encodeRequestParameters(data)
    return httpClient
        .post("/appart/" + data.id, params)
        .then((response) => {
            return response
        })
        .catch((error) => {
            throw error
        })
}

export function deleteApartment(data) {
    data = formatData(apartmentFormat, data)
    return httpClient
        .delete("/appart/" + data.id)
        .then((response) => {
            return response
        })

        .catch((error) => {
            throw error
        })
}
